"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const aws_react_1 = require("@mit/aws-react");
const AuthService_1 = __importDefault(require("../services/AuthService"));
// @ts-ignore
const api_config_1 = __importDefault(require("./api-config"));
class BaseController extends aws_react_1.BaseApiController {
    constructor() {
        var _a, _b;
        super();
        this.getAuthorizationHeaders = () => __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            return {
                Authorization: `Bearer ${token}`
            };
        });
        this.requestHeaderGet = (moreHeaders) => __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const options = {
                method: "GET",
                headers: new Headers(Object.assign({ 'Authorization': 'Bearer ' + token }, moreHeaders))
            };
            return options;
        });
        this.requestHeaderPost = (requestBody, moreHeaders) => __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const options = {
                method: "POST",
                headers: new Headers(Object.assign({ 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, moreHeaders)),
                body: moreHeaders && moreHeaders['Content-Type'] && moreHeaders['Content-Type'] != 'application/json' ? requestBody : JSON.stringify(requestBody)
            };
            return options;
        });
        this.requestHeaderPut = (requestBody, moreHeaders) => __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const options = {
                method: "PUT",
                headers: new Headers(Object.assign({ 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, moreHeaders)),
                body: moreHeaders && moreHeaders['Content-Type'] && moreHeaders['Content-Type'] != 'application/json' ? requestBody : JSON.stringify(requestBody)
            };
            return options;
        });
        this.requestHeaderPatch = (requestBody, moreHeaders) => __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const options = {
                method: "PATCH",
                headers: new Headers(Object.assign({ 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, moreHeaders)),
                body: moreHeaders && moreHeaders['Content-Type'] && moreHeaders['Content-Type'] != 'application/json' ? requestBody : JSON.stringify(requestBody)
            };
            return options;
        });
        let isGlobalEnabled = (_a = localStorage.getItem('isGlobalEnabled') === 'true') !== null && _a !== void 0 ? _a : false;
        let configKey = (isGlobalEnabled ? 'global' : 'regional');
        this.apiHost = (_b = api_config_1.default[configKey].apiHost) !== null && _b !== void 0 ? _b : '';
        this.apiPathCovid = api_config_1.default[configKey].paths.apiPathCovid;
        this.apiPathDigitalId = api_config_1.default[configKey].paths.apiPathDigitalId;
        this.apiPathMedical = api_config_1.default[configKey].paths.apiPathMedical;
        this.apiPathPass = api_config_1.default[configKey].paths.apiPathPass;
        this.apiPathVaccine = api_config_1.default[configKey].paths.apiPathVaccine;
        this.apiPathFeature = api_config_1.default[configKey].paths.apiPathFeature;
        this.apiPathVaccineV2 = api_config_1.default[configKey].paths.apiPathVaccineV2;
    }
    checkStatusCode(status) {
        return status >= 200 && status < 300;
    }
    genericResponse(response) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkStatusCode(response.status)) {
                // let data = await response.json()
                return {
                    success: true
                };
            }
            else {
                return {
                    error: true
                };
            }
        });
    }
}
exports.default = BaseController;
